import da from './da.json';
import de from './de.json';
import en from './en.json';
import es from './es.json';
import fi from './fi.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import sv from './sv.json';
import tr from './tr.json';
import cs from './cs.json';
import hu from './hu.json';
import sk from './sk.json';
import ro from './ro.json';
import sl from './sl.json';
import sr from './sr.json';
import bg from './bg.json';
import hr from './hr.json';
import zhCN from './zh-CN.json';

export default {
  da,
  de,
  en,
  es,
  fi,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  sv,
  tr,
  cs,
  hu,
  sk,
  ro,
  sl,
  sr,
  bg,
  hr,
  'zh-CN': zhCN,
};
